import { parse, stringify } from '@contra/utilities/queryString';

export const removeSearchParameter = (path: string, parameterName: string) => {
  if (!path) {
    return '';
  }

  const [nextPath, firstQuery] = path.split('?');

  if (!firstQuery) {
    return nextPath;
  }

  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    [parameterName]: removed,
    ...rest
  } = parse(firstQuery);

  const searchString = stringify(rest);

  if (searchString === '') {
    return nextPath;
  }

  return nextPath + '?' + searchString;
};
